<template>
  <v-container fluid>
    <!-- <v-dialog v-model="show" > -->
    <v-card elevation="0">
      <v-toolbar>
        <v-icon>history</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>
                &nbsp;Contactos con el Sr {{ infoPersona.nombreCompleto }} -
                <span @click="showId = true">{{
                  infoPersona.documentoCompleto
                }}</span>
              </div>
              <span v-if="showId" class="caption"
                >ID Persona: {{ infoPersona.id }}</span
              >
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hideActiveTask"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-row dense>
        <v-col>
          <v-alert color="info" dark>
            <v-row no-gutters align="center">
              <span v-if="user.login == infoPersona.asignadoA"
                >Caso Propio</span
              >
              <span v-else
                >El Cliente esta
                {{ infoPersona.situacionAsignacionGestion }}</span
              >
              <v-spacer></v-spacer>
              <v-btn
                color="indigo"
                label
                @click.stop="tomarCaso"
                small
                v-if="
                  user.puedeTomarCasoGestion &&
                  user.login != infoPersona.asignadoA
                "
                >Tomar Caso</v-btn
              >
            </v-row>
          </v-alert>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3">
          <v-checkbox
            v-model="iDebitos"
            label="Incluir Débitos"
            dense
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            v-model="iGestionesTel"
            label="Incluir Gestiones Telefónicas"
            dense
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            v-model="iGestiones"
            label="Incluir Gestiones"
            dense
          ></v-checkbox>
        </v-col>
        <v-col cols="3">
          <v-checkbox
            v-model="iMensajes"
            label="Incluir Mensajes"
            dense
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="3" v-if="iGestiones || iGestionesTel">
          <v-checkbox v-model="filtrarTareas" label="Filtrar Tareas" />
        </v-col>
        <v-col cols="3" v-if="filtrarTareas">
          <v-autocomplete
            :items="listaTareas"
            v-model="tareaId"
            item-text="descripcion"
            item-value="id"
            dense
          />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3">
          <v-btn color="green" dark @click="loadData()"> Consultar</v-btn>
        </v-col>
      </v-row>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :loading="loading"
              :items="listaTotal"
              v-model="selectedRow"
              :server-items-length="totalItems"
              :options.sync="options"
              :footer-props="{ itemsPerPageOptions: options.rowsPerPageItems }"
            >
              <template slot="no-data">
                <v-alert :value="true" color="grey" icon="warning">
                  No se encontraron gestiones.
                </v-alert>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-xs-left caption">
                    <tr>
                      {{
                        item.fecha
                          | dateParse("YYYY-MM-DD")
                          | dateFormat("DD-MM-YYYY")
                      }}
                    </tr>
                    <tr class="text-center font-weight-light caption">
                      {{
                        item.fecha
                          | dateParse("YYYY-MM-DD HH:mm")
                          | dateFormat("HH:mm")
                      }}
                    </tr>
                  </td>

                  <td class="text-xs-left caption">
                    <tr>
                      {{
                        item.tareaDescripcion
                      }}
                    </tr>
                    <tr v-if="item.telefonoContactado">
                      al
                      {{
                        item.telefonoContactado
                      }}
                    </tr>
                  </td>

                  <td class="text-xs-left caption">
                    <tr v-if="item.tipoPersonaContactadaDescripcion != ''">
                      Contacto con
                      {{
                        item.tipoPersonaContactadaDescripcion
                      }}
                    </tr>
                    <tr>
                      {{
                        item.respuestaDescripcion
                      }}
                    </tr>
                    <tr>
                      <span class="overline">{{ item.comentarios }}</span>
                    </tr>
                  </td>

                  <td class="text-xs-left caption">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{
                          item.responsable
                        }}</span>
                      </template>
                      <span> {{ item.descripcionSector }} </span>
                    </v-tooltip>
                  </td>

                  <td class="text-xs-left caption">
                    <tr>
                      <v-switch
                        v-show="item.tipoGestionDescripcion != 'Mensajes'"
                        v-model="item.destacada"
                        @change="destacar(item.id, item.destacada)"
                      ></v-switch>
                    </tr>
                    <tr>
                      <v-tooltip
                        v-if="checkCanAccess('ap-puede-eliminar-gestion')"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            v-on="on"
                            @click="eliminarGestion(item)"
                          >
                            <v-icon color="grey">delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Anular gestión</span>
                      </v-tooltip>
                    </tr>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-divider></v-divider>
      </v-card-actions>
    </v-card>
    <app-loading :loading="loading"></app-loading>
    <!-- </v-dialog> -->
    <v-footer fixed>
      <v-btn color="blue darken-1" text @click.stop="hideActiveTask"
        >Cerrar</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn color="green" dark @click="nuevoContacto()"> Nuevo Contacto</v-btn>
      <!-- 
      <v-btn color="green" dark @click="nuevoContactoAplicacion()">
        Nuevo Contacto Aplicacion</v-btn -->
      >
    </v-footer>
  </v-container>
</template>

<script>
import { http } from "@/axios";

import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    infoPersona: {},
    totalItems: 0,
    totalItemsCargados: 0,
    pageCreditos: 0,
    showId: false,
    showCuentaCorriente: false,
    showLog: false,
    options: {
      // definición de paginación
      sortDesc: [true],
      sortBy: ["fecha"],
      page: 1,
      itemsPerPage: 20,
      rowsPerPageItems: [5, 10, 20],
    },
    iDebitos: false,
    iGestiones: true,
    iGestionesTel: true,
    iMensajes: false,
    filtrarTareas: false,
    aplicarTareas: false,
    iAplicacion: false,
    tareaId: 0,
    selectedRow: [],
    headers: [
      // definición de columnas
      { text: "Fecha", value: "fecha", width: "100" },
      { text: "Tarea", value: "tarea" },
      { text: "Respuesta/Comentarios", value: "respuesta" },
      { text: "Responsable", value: "responsable" },
      { text: "Destacada", value: "destacada" },
    ],
    listaTareas: [],
  }),
  props: {
    personaId: {
      type: String,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.personaId) {
      this.showId = false;
      this.pageCreditos = 0;
      this.items = [];

      this.loadDatosPersona();
      this.setFiltroRiesgo(this.user.sectorDescripcion);
    }
    this.loadTareas();
  },
  computed: {
    ...mapGetters(["checkCanAccess", "user"]),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  watch: {
    visible: function () {
      if (this.visible) {
        this.showId = false;
        this.pageCreditos = 0;
        this.items = [];
        this.loadDatosPersona();
      }
    },

    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "hideActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async nuevoContacto() {
      var params = {
        width: 500,
        personaId: this.personaId,
        gestionAsignada: false,
        tipoGestionId: this.user.tipoGestionId,
        isSubTask: true,
      };
      //Vue.$log.debug(params);

      this.setActiveSubTask({ task: "gestion-caso-puntual", props: params });
    },

    async nuevoContactoAplicacion() {
      var params = {
        width: 500,
        personaId: this.personaId,
        gestionAsignada: false,
        tipoGestionId: this.user.tipoGestionId,
        isSubTask: true,
      };
      //Vue.$log.debug(params);

      this.setActiveSubTask({
        task: "contactos-persona-aplicaciones",
        props: params,
      });
    },

    async loadDatosPersona() {
      // cargo la info de la persona
      this.loading = true;
      try {
        var result = await http.get(
          "personas/inforesumida?id=" +
            this.personaId +
            "&cargarSituacionGestion=true"
        );

        this.infoPersona = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadData();
      this.loading = false;
    },
    async tomarCaso() {
      const res = await this.$dialog.confirm({
        text: "El caso se encuentra asignado a otro usuario ¿Está seguro que quiere tomarlo?",
        title: "Tomar Caso ",
        persistent: true, // Parece que no funciona...
      });

      if (!res) {
        return;
      }

      this.loading = true;
      try {
        var asignacionCommand = {
          personaId: this.personaId,
          gestorId: this.user.id,
          cerrarGestionesAnteriores: true,
          empresaId: 1,
        };

        var result = await http.post(
          "gestion/asignargestionmorapuntual",
          JSON.stringify({ caso: asignacionCommand })
        );

        this.loadDatosPersona();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadData() {
      if (!this.infoPersona.id) return;

      var id = this.infoPersona.id;
      try {
        this.loading = true;
        var result = await http.get(
          "gestion/listgestionesporpersona?personaId=" +
            id +
            "&incluirGestiones=" +
            this.iGestiones +
            "&incluirTelefonicas=" +
            this.iGestionesTel +
            "&incluirDebitos=" +
            this.iDebitos +
            "&incluirMensajes=" +
            this.iMensajes +
            "&filtroTarea=" +
            this.tareaId +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : "true")
        );

        this.listaTotal = result.list;
        this.totalItems = result.totalCount;
        this.loading = false;
      } catch (error) {
        // Error
        this.alertError(error);
        this.loading = false;
      }
    },
    async destacar(id, estado) {
      if (!id) return;

      try {
        await http.put(
          "gestion/updategestiondestacada",
          JSON.stringify({
            id: id,
            estado: estado,
          })
        );

        //this.loadGestiones();
      } catch (error) {
        console.error(error);
      }
    },
    async loadTareas() {
      try {
        var result = await http.get("tipostareas");
        result.list.unshift({ id: 0, descripcion: "cualquiera" });
        this.listaTareas = result.list;
      } catch (err) {
        return;
      }
    },
    async setFiltroRiesgo(sector) {
      if (sector.includes("Riesgo") || sector.includes("Impactos")) {
        this.iDebitos = true;
        this.iGestiones = false;
        this.iGestionesTel = false;
        this.iMensajes = false;
      }
      return;
    },
    async eliminarGestion(item) {
      if (
        confirm(
          "¿Confirma la eliminación de gestión " +
            item.comentarios +
            " del día " +
            item.fecha +
            "?"
        )
      ) {
        try {
          this.loading = true;
          await http.delete("gestion/eliminargestion?id=" + item.id);
          this.alertSuccess("Se elimino la gestión correctamente.");
          this.loadData();
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      }
    },
  },
};
</script>
